// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"eaeda337","95":"8f18e0a1","374":"ea640a76","383":"4c83041f","412":"c1faf67b","416":"2bc7f38c","557":"637ec2c5","580":"f0b82427","738":"54767e1f","788":"e6a122ec","796":"8c0e4aa9","807":"7317ebae","823":"a14a623c","837":"ca8e074c"}[chunkId] + ".chunk.js";
};